export default __webpack_public_path__ + "static/media/TempIcon.ad4acece.png";